export const NAV_SECTION_IDS = {
  OVERVIEW: 'overviewSection',
  APPEARANCE: 'appearanceSection',
  TEMPERAMENT: 'temperamentSection',
  HEALTH: 'healthSection',
  HISTORY: 'historySection',
  FAQS: 'faqsSection'
};

export const SCORECARD_SECTION_ID = 'scorecardSection';

export const NAVIGATION = {
  [NAV_SECTION_IDS.OVERVIEW]: 'Overview',
  [NAV_SECTION_IDS.APPEARANCE]: 'Appearance & Grooming',
  [NAV_SECTION_IDS.TEMPERAMENT]: 'Temperament & Characteristics',
  [NAV_SECTION_IDS.HEALTH]: 'Health',
  [NAV_SECTION_IDS.HISTORY]: 'History',
  [NAV_SECTION_IDS.FAQS]: 'FAQs'
};
